import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getMediaTypeFromIndex } from '../../../api/CoreAPI'
import { useWindowSize } from '../../../hooks/useWindowSize'
import { styled } from '../../../lib/stitches'
import { useTreeState } from '../../../stores/Root'
import OpenStudioButton from '../../core/OpenStudioButton'
import VolumeSlider from '../../studio/controls/VolumeSlider'
import { OpenDetailPageButton, PlayerSection } from './Common'

const Spacer = styled('div', {
  width: '22px'
})

const segmentDetails = (type, id) => {
  window.analytics.track('Button Clicked', {
    button: 'see details',
    source: window.location.pathname,
    location: 'global player',
    type: type,
    id: id
  })
}

const ExtraControls = () => {
  const { globalPlayer } = useTreeState()
  const [mediaType, setMediaType] = useState(null)
  const navigate = useNavigate()
  const { isBreakpoint } = useWindowSize()
  const isMobile = !isBreakpoint('tablet')

  useEffect(() => {
    if (globalPlayer.arpMediaIndex === null) return null

    getMediaTypeFromIndex(globalPlayer.arpMediaIndex).then((mt) => setMediaType(mt))
  }, [globalPlayer.arpMediaIndex])

  if (isMobile) return null
  return (
    <PlayerSection css={{ justifyContent: 'end' }}>
      <VolumeSlider
        value={globalPlayer.volume}
        setGain={globalPlayer.setVolume}
        hideThumb={true}
        tall={true}
      />
      <Spacer />
      <OpenDetailPageButton
        onClick={() => {
          segmentDetails(mediaType, globalPlayer.arpMediaIndex)
          navigate(`/${mediaType}?token=${globalPlayer.arpMediaIndex}`)
        }}
        disabled={globalPlayer.arpMediaIndex === null || mediaType === null}
      />
      <Spacer />
      <OpenStudioButton
        index={globalPlayer.arpMediaIndex}
        mediaType={mediaType}
        disabled={mediaType === null}
        location="global player"
        text="+ Open Studio"
        large
        purple
      />
    </PlayerSection>
  )
}

export default observer(ExtraControls)
